import { JobOffersTranslation } from 'locales/de/pages/Jobmarket/jobOffers';

const en: JobOffersTranslation = {
  title: 'Job Offers',
  detailTitle: 'Job Offer',
  searchbarTitle: 'Title',
  jobTypes: {
    1: 'Other',
    2: 'Student Employee',
    3: '(Final) Thesis',
    4: 'Industrial project work',
    5: 'Abroad internship',
    6: 'Entry-level and Trainee',
    7: 'Final Thesis',
    8: 'Voluntary Internship',
    9: 'Internship',
    10: 'Dual Study',
    11: 'Dual Study (in-depth practice training)',
    12: 'Student Assistant',
    13: 'Student Job',
    14: 'University Assistant'
  },
  openFailed: 'Job offer could not be opened',
  notFound: 'Job offer could not be found',
  updatedOn: 'Updated on',
  postedOn: 'Posted on ',
  start: 'Start',
  downloadDescription: 'Description',
  downloadAttachement: 'Attachement',
  changeJobType: {
    disabledStudentAssistantJobTypeTooltip:
      'Student assistant position is only available for internal jobofferings.',
    disabledJobTypeTooltip:
      'Either your period for switching has expired or you cannot switch to a fee-based category yourself. Please contact for this the Career Center. E-mail: careercenter@th-rosenheim.de',
    cantChangeFromPaidTooltip:
      'The type of a paid job offer can only be changed within the first 3 days.',
    changeFromFreeToPaidJobTypeInfoBoxTitle: 'IMPORTANT!',
    changeFromFreeToPaidJobTypeInfoBox:
      'If you change the type of job advertisement to a chargeable type, the current publication period remains unchanged. You must therefore also pay for the period in which the job advertisement was still listed under a different type!'
  },
  inspectArticle: 'Inspect article',
  startDate: 'Start Date',
  createdAt: 'Created On',
  activatedAt: 'Activated On',
  jobOffer: 'Job offer',
  jobOffers: 'Job offers',
  openCompanyProfile: 'Open company profile',
  forbidden: "You may only see your own company's job offers.",
  deleteNotAllowed: 'Active JobOffers can not be deleted',
  publication: 'Publication',
  zipcode: 'ZIP-Code',
  radius: 'Radius',
  applyNow: 'Apply Now'
};

export default en;
